module.exports = __webpack_public_path__ + "static/media/mshtml_32552.41d89217.ico";